var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainOffers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1211 26.7016L18.1211 26.7016L18.1192 26.7036C17.7065 27.1277 17.1331 27.3806 16.5 27.3806C15.8667 27.3806 15.2922 27.1274 14.8789 26.7141L3.62892 15.4641C3.20259 15.0378 2.95 14.4632 2.95 13.8306V5.08057C2.95 3.81602 3.98546 2.78057 5.25 2.78057H14C14.6333 2.78057 15.2078 3.03369 15.6211 3.44699L26.8711 14.697C27.2854 15.1114 27.55 15.6987 27.55 16.3306C27.55 16.9636 27.2972 17.5371 26.873 17.9497L26.873 17.9497L26.8711 17.9516L18.1211 26.7016ZM16.3585 25.2344L16.5001 25.3762L16.6416 25.2343L25.3916 16.4593L25.5326 16.3179L25.3914 16.1766L14.1414 4.92665L13.8 4.58522V4.88057H5.25H5.05V5.08057V13.8306V13.9133L5.1085 13.9719L16.3585 25.2344Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.375 10.0806C9.41053 10.0806 10.25 9.2411 10.25 8.20557C10.25 7.17003 9.41053 6.33057 8.375 6.33057C7.33947 6.33057 6.5 7.17003 6.5 8.20557C6.5 9.2411 7.33947 10.0806 8.375 10.0806Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainOffers);
export default __webpack_public_path__ + "static/media/mainOffers.35462625ab49137bf5777973e5847ee0.svg";
export { ForwardRef as ReactComponent };